import React from "react";
import DomainCompoment from "../../components/domain/Domain";

const Domen = () => {
  return <DomainCompoment />;
};

export default Domen;
